module.exports = __webpack_public_path__ + "img/greater_than.5c8c9457.svg";